import { Component, inject } from '@angular/core';
import {AccessService} from '../../services/access.service';
import {DataService} from "../../services/data.service";
import {LocalStorageService} from "../../services/local-storage.service";
import {Router, RouterLink} from "@angular/router";
import {MessageService} from "../../services/message.service";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    imports: [
        FormsModule,
        RouterLink
    ],
    styleUrl: './navigation.component.scss'
})
export class NavigationComponent {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);
    private messageService = inject(MessageService);

    searchString: string = '';

    logout(event): void {
        event.preventDefault();
        this.dataService.request("User/logout").subscribe(() => {
            this.localStorageService.removeItem('token');
            this.accessService.token = '';
            this.accessService.user = null;
            this.router.navigate(['/login']);
        });
    }

    search(): void {
        if (this.searchString !== '') {
            this.messageService.setItem('search', this.searchString);
            this.searchString = ''
            this.router.navigate(['/task']);
        }
    }
}
